import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const useFormValidation = (schema, defaultValues = {}) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "onChange",
  });

  return methods; // this will include clearErrors, errors, etc.
};

export default useFormValidation;
